import { object, string } from 'yup';

import { FormErrorMessage } from '~/constants/messages';

export const validationSchema = object().shape({
  cancelReason: string().required(FormErrorMessage.required),
});
